import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { Item } from 'screens/AssetsScreen/AssetList/Item/Item';
import { AssetListItemContainerProps } from 'screens/AssetsScreen/AssetList/Item/types';
import { ASSET_AVATAR } from 'service/api/constants';
import {
  selectSearchAsset,
  selectSearchOrganisation,
} from 'store/search/selectors';

export const ListItem: React.FC<AssetListItemContainerProps> = ({
  cacheKey,
  id,
  onSelect,
  selected,
}) => {
  const asset = useSelector((state) => selectSearchAsset(state, id));
  const organisation = useSelector((state) =>
    selectSearchOrganisation(state, asset.organisation_id),
  );
  const toggleChosen = React.useCallback(() => onSelect(id), [id, onSelect]);

  return (
    <Item
      asset={asset}
      selected={selected}
      organisation={organisation}
      onPressThumbnail={toggleChosen}
      onPress={toggleChosen}
      remoteThumbnailUrl={
        asset.details.avatar ? ASSET_AVATAR(asset.id, cacheKey) : undefined
      }
    />
  );
};
